module.exports = __webpack_public_path__ + "static/img/aburamushi.2553769.jpg";